import { useState, useEffect } from "react";
import "./myorders.css";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
interface Status {
  StatusId: number;
  Status: string;
  className: string;
}
interface Order {
  orderNumber: string;
  createdon: string;
  NoofApplications: string;
  NoofServices: string;
  orderStatus: string;
  action: string;
}

interface ErrorOrder {
  error: string;
}

type OrderRow = Order | ErrorOrder;

const MyOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState<OrderRow[]>([]);
  const [statuses, setStatuses] = useState<Status[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<number | string>("All");
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 10;

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axiosInstance.get("/api/user/getOrders");
        setOrders(response.data.orders || response.data || []);
        if (response.data.Status && Array.isArray(response.data.Status)) {
          setStatuses(response.data.Status);
        }
      } catch (err) {
        setError("Failed to load orders");
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const filteredOrders = orders.filter((order) => {
    if ("error" in order) return true;
    const matchSearch = !searchText || 
      (order.orderNumber && order.orderNumber.toLowerCase().includes(searchText.toLowerCase()));
    const matchStatus = selectedStatus === "All" || 
      (order.orderStatus && selectedStatus !== "All" && 
       order.orderStatus === selectedStatus);
    
    return matchSearch && matchStatus;
  });
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchText, selectedStatus]);

  const getMatchingStatus = (orderStatus: any) => {
  
    if (orderStatus === null || orderStatus === undefined) {
      return null;
    }
  
    return statuses.find(status =>
      status.StatusId === orderStatus
    );
  };
  
  const formatDate = (dateString: string | Date) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ''; // Invalid date check

  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


  return (
    <>
      <div className="row up-form-r layout-border rounded-3">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-1 p-3 border-bottom py-2">
          <div>
            <h1 className="ff-semibold text-black mb-1 font-18">My Orders</h1>
            <p className="font-13 text-muted mb-0">Please check your orders</p>
          </div>
          <div>
            <select
              className="form-select px-3 font-13 ff-medium"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value === "All" ? "All" : parseInt(e.target.value))}
            >
              <option value="All">All orders</option>
              {statuses.map((status) => (
                <option key={status.StatusId} value={status.StatusId}>
                  {status.Status.trim()}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="p-0 table-search border-bottom d-flex align-items-center gap-2 ps-3 up-form">
          <div>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 5.59587C1 6.24096 1.12071 6.87974 1.35523 7.47572C1.58975 8.07171 1.93349 8.61323 2.36683 9.06938C2.80018 9.52553 3.31462 9.88737 3.88081 10.1342C4.447 10.3811 5.05383 10.5082 5.66667 10.5082C6.2795 10.5082 6.88634 10.3811 7.45252 10.1342C8.01871 9.88737 8.53316 9.52553 8.9665 9.06938C9.39984 8.61323 9.74358 8.07171 9.97811 7.47572C10.2126 6.87974 10.3333 6.24096 10.3333 5.59587C10.3333 4.95078 10.2126 4.31201 9.97811 3.71603C9.74358 3.12004 9.39984 2.57852 8.9665 2.12237C8.53316 1.66622 8.01871 1.30438 7.45252 1.05752C6.88634 0.810654 6.2795 0.683594 5.66667 0.683594C5.05383 0.683594 4.447 0.810654 3.88081 1.05752C3.31462 1.30438 2.80018 1.66622 2.36683 2.12237C1.93349 2.57852 1.58975 3.12004 1.35523 3.71603C1.12071 4.31201 1 4.95078 1 5.59587Z"
                stroke="#9B9B9B"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13 13.316L9 9.10547"
                stroke="#9B9B9B"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            className="form-control myorders-search p-0 border-0 rounded-0 mb-0"
            placeholder="Search orders ID"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div id="orders-list" style={{ height: '600px', overflowY: 'auto' }}>
          {loading ? (
            <div className="text-center py-4">Loading orders...</div>
          ) : error ? (
            <div className="text-danger text-center py-4">{error}</div>
          ) : currentOrders.length === 0 ? (
            <div className="text-center py-4">No orders found.</div>
          ) : (
            currentOrders.map((order, idx) =>
              "error" in order ? (
                <div
                  className="bg-light-red text-red px-3  ff-semibold font-13 d-flex align-items-center gap-2 py-2 my-3"
                  key={idx}
                >
                  <div>
                    <svg
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99995 0C5.43407 0 5.83864 0.212286 6.08638 0.566853L6.13411 0.639585L9.82252 6.79815C9.93461 6.99228 9.9956 7.21169 9.99977 7.43583C10.0039 7.65997 9.95116 7.88149 9.84637 8.07967C9.74159 8.27785 9.58822 8.44619 9.40063 8.56893C9.21304 8.69166 8.99737 8.76479 8.77382 8.78145L8.68518 8.78509H1.30972C1.08594 8.78257 0.866439 8.72339 0.671715 8.61308C0.476991 8.50277 0.31339 8.34492 0.196184 8.15427C0.0789777 7.96361 0.0119871 7.74637 0.00146504 7.52282C-0.00905701 7.29927 0.0372326 7.0767 0.136013 6.87588L0.181016 6.79178L3.86761 0.637766C3.98564 0.443124 4.15185 0.282185 4.35019 0.170474C4.54853 0.0587625 4.77231 5.00791e-05 4.99995 0ZM4.99995 4.24117H4.54537L4.49219 4.24435C4.38171 4.25749 4.27988 4.3107 4.206 4.39389C4.13211 4.47708 4.09131 4.58448 4.09131 4.69574C4.09131 4.80701 4.13211 4.9144 4.206 4.9976C4.27988 5.08079 4.38171 5.13399 4.49219 5.14713L4.54537 5.15032V6.51404L4.54856 6.56722C4.56052 6.66869 4.60632 6.76317 4.67857 6.83542C4.75082 6.90766 4.8453 6.95346 4.94676 6.96543L4.99995 6.96861H5.45452L5.50771 6.96543C5.60918 6.95346 5.70365 6.90766 5.7759 6.83542C5.84815 6.76317 5.89395 6.66869 5.90591 6.56722L5.9091 6.51404L5.90591 6.46085C5.89505 6.36811 5.85588 6.28096 5.79374 6.21126C5.73161 6.14156 5.64951 6.09268 5.55862 6.07128L5.50771 6.06219L5.45452 6.05946V4.69574L5.45134 4.64256C5.43937 4.54109 5.39357 4.44661 5.32133 4.37437C5.24908 4.30212 5.1546 4.25632 5.05313 4.24435L4.99995 4.24117ZM5.00449 2.87745L4.94676 2.88063C4.83628 2.89377 4.73445 2.94698 4.66057 3.03017C4.58669 3.11336 4.54588 3.22076 4.54588 3.33202C4.54588 3.44329 4.58669 3.55068 4.66057 3.63388C4.73445 3.71707 4.83628 3.77027 4.94676 3.78341L4.99995 3.7866L5.05768 3.78341C5.16816 3.77027 5.26999 3.71707 5.34387 3.63388C5.41776 3.55068 5.45856 3.44329 5.45856 3.33202C5.45856 3.22076 5.41776 3.11336 5.34387 3.03017C5.26999 2.94698 5.16816 2.89377 5.05768 2.88063L5.00449 2.87745Z"
                        fill="#D24242"
                      />
                    </svg>
                  </div>
                  {order.error}
                </div>
              ) : (
                <div className="myorders-order-box" key={idx}>
                  <div className="myorders-order-row">
                    <div className="col-id  myorders-col">
                      <small className="text-muted font-12 d-block">
                        Order ID
                      </small>
                      <span className="text-main ff-semibold font-13">
                        {order.orderNumber}
                      </span>
                    </div>
                    <div className="col-date myorders-col">
                      <small className="text-muted font-12 d-block">Date</small>
                      <span className="ff-semibold text-black font-13">
                       <span>{formatDate(order.createdon)}</span>
                      </span>
                    </div>
                    <div className="col-applicants myorders-col">
                      <small className="text-muted font-12 d-block">
                        No of applicant
                      </small>
                      <span className="ff-semibold text-black font-13">
                        {order.NoofApplications} Applications
                      </span>
                    </div>
                    <div className="col-services myorders-col">
                      <small className="text-muted font-12 d-block">
                        No of Services
                      </small>
                      <span className="ff-semibold text-black font-13">
                        {order.NoofServices} Services
                      </span>
                    </div>
                    <div className="col-status myorders-col">
                      <small className="text-muted font-12 d-block">Status</small>
                      {(() => {
                        const matchingStatus = getMatchingStatus(order.orderStatus);
                        return (
                          <span
                            className={`fw-semibold font-13 status-${matchingStatus?.Status?.toLowerCase().trim().replace(/\s+/g, '') || ''}`}
                          >
                       
                            {matchingStatus ? matchingStatus.Status.trim() : (order.orderStatus || 'N/A')}
                          </span>
                        );
                      })()}
                    </div>
                    <div className="col-action myorders-col" onClick={() => navigate(`/accounts/orderDetail?orderNumber=${order.orderNumber}`)}>
                      <button className="btn btn-outline-secondary font-12">
                        view Details
                      </button>
                    </div>
                  </div>
                </div>
              )
            )
          )}
        </div>

        {totalPages > 1 && (
          <nav className="d-flex justify-content-center mt-4">
            <ul className="pagination custom-pagination1">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button 
                  className="page-link rounded-circle"
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                >
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.5 0.785156L1.5 5.78516L6.5 10.7852"
                      stroke="#9A9A9A"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </li>
              
              {Array.from({ length: totalPages }, (_, index) => {
                const pageNumber = index + 1;
                return (
                  <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                    <button 
                      className="page-link rounded-circle"
                      onClick={() => setCurrentPage(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}
              
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button 
                  className="page-link rounded-circle"
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                >
                  <svg
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5 1l8 7-8 7"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </button>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </>
  );
};

export default MyOrders;
